export const FILTERS_UPDATE = 'FILTERS_UPDATE'
export const FILTERS_SUBMIT_SUCCESS = 'FILTERS_SUBMIT_SUCCESS'
export const FILTERS_SUBMIT_FAILURE = 'FILTERS_SUBMIT_FAILURE'
export const CLEAR_CHECKBOX_FILTERS = 'CLEAR_CHECKBOX_FILTERS'

// Action will submit filter request data by default
// Pass { submitFilters: false } if just updating state
export const filtersUpdate = (filters = {}) => {
  const {
    debounce = false,
    refresh = false,
    statQuickFilter = false,
    submitFilters = true,
  } = filters
  return {
    payload: { filters, submitFilters },
    type: FILTERS_UPDATE,
    submitFilters,
    debounce,
    refresh,
    statQuickFilter,
  }
}

export const clearCheckboxFilters = selected => ({
  type: CLEAR_CHECKBOX_FILTERS,
  selected,
})
